import createBrowserHistory from 'history/lib/createBrowserHistory'

export default createBrowserHistory();



/** WEBPACK FOOTER **
 ** ./app/history.js
 **/